var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c, _d;
import { Ether, NativeCurrency, Token, WETH9 } from '@uniswap/sdk-core';
import { UNI_ADDRESS } from './addresses';
import { SupportedChainId } from './chains';
export var USDC_MAINNET = new Token(SupportedChainId.MAINNET, '0xA0b86991c6218b36c1d19D4a2e9Eb0cE3606eB48', 6, 'USDC', 'USD//C');
export var USDC_ROPSTEN = new Token(SupportedChainId.ROPSTEN, '0x07865c6e87b9f70255377e024ace6630c1eaa37f', 6, 'USDC', 'USD//C');
export var USDC_RINKEBY = new Token(SupportedChainId.RINKEBY, '0x4DBCdF9B62e891a7cec5A2568C3F4FAF9E8Abe2b', 6, 'tUSDC', 'test USD//C');
export var USDC_GOERLI = new Token(SupportedChainId.GOERLI, '0x07865c6e87b9f70255377e024ace6630c1eaa37f', 6, 'USDC', 'USD//C');
export var USDC_KOVAN = new Token(SupportedChainId.KOVAN, '0x31eeb2d0f9b6fd8642914ab10f4dd473677d80df', 6, 'USDC', 'USD//C');
export var USDC_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x7F5c764cBc14f9669B88837ca1490cCa17c31607', 6, 'USDC', 'USD//C');
export var USDC_OPTIMISTIC_KOVAN = new Token(SupportedChainId.OPTIMISTIC_KOVAN, '0x3b8e53b3ab8e01fb57d0c9e893bc4d655aa67d84', 6, 'USDC', 'USD//C');
export var USDC_ARBITRUM = new Token(SupportedChainId.ARBITRUM_ONE, '0xFF970A61A04b1cA14834A43f5dE4533eBDDB5CC8', 6, 'USDC', 'USD//C');
export var USDC_ARBITRUM_RINKEBY = new Token(SupportedChainId.ARBITRUM_RINKEBY, '0x09b98f8b2395d076514037ff7d39a091a536206c', 6, 'USDC', 'USD//C');
export var USDC_ARBITRUM_GOERLI = new Token(SupportedChainId.ARBITRUM_GOERLI, '0x179522635726710Dd7D2035a81d856de4Aa7836c', 6, 'USDC', 'USD//C');
export var USDC_POLYGON = new Token(SupportedChainId.POLYGON, '0x2791bca1f2de4661ed88a30c99a7a9449aa84174', 6, 'USDC', 'USD//C');
export var USDC_POLYGON_MUMBAI = new Token(SupportedChainId.POLYGON_MUMBAI, '0xe11a86849d99f524cac3e7a0ec1241828e332c62', 6, 'USDC', 'USD//C');
export var AMPL = new Token(SupportedChainId.MAINNET, '0xD46bA6D942050d489DBd938a2C909A5d5039A161', 9, 'AMPL', 'Ampleforth');
export var DAI = new Token(SupportedChainId.MAINNET, '0x6B175474E89094C44Da98b954EedeAC495271d0F', 18, 'DAI', 'Dai Stablecoin');
export var DAI_ARBITRUM_ONE = new Token(SupportedChainId.ARBITRUM_ONE, '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', 18, 'DAI', 'Dai stable coin');
export var DAI_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0xDA10009cBd5D07dd0CeCc66161FC93D7c9000da1', 18, 'DAI', 'Dai stable coin');
export var USDC = (_a = {},
    _a[SupportedChainId.MAINNET] = USDC_MAINNET,
    _a[SupportedChainId.ARBITRUM_ONE] = USDC_ARBITRUM,
    _a[SupportedChainId.OPTIMISM] = USDC_OPTIMISM,
    _a[SupportedChainId.ARBITRUM_RINKEBY] = USDC_ARBITRUM_RINKEBY,
    _a[SupportedChainId.ARBITRUM_GOERLI] = USDC_ARBITRUM_GOERLI,
    _a[SupportedChainId.OPTIMISTIC_KOVAN] = USDC_OPTIMISTIC_KOVAN,
    _a[SupportedChainId.POLYGON] = USDC_POLYGON,
    _a[SupportedChainId.POLYGON_MUMBAI] = USDC_POLYGON_MUMBAI,
    _a[SupportedChainId.GOERLI] = USDC_GOERLI,
    _a[SupportedChainId.RINKEBY] = USDC_RINKEBY,
    _a[SupportedChainId.KOVAN] = USDC_KOVAN,
    _a[SupportedChainId.ROPSTEN] = USDC_ROPSTEN,
    _a);
export var DAI_POLYGON = new Token(SupportedChainId.POLYGON, '0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', 18, 'DAI', 'Dai Stablecoin');
export var USDT_POLYGON = new Token(SupportedChainId.POLYGON, '0xc2132d05d31c914a87c6611c10748aeb04b58e8f', 6, 'USDT', 'Tether USD');
export var WBTC_POLYGON = new Token(SupportedChainId.POLYGON, '0x1bfd67037b42cf73acf2047067bd4f2c47d9bfd6', 8, 'WBTC', 'Wrapped BTC');
export var USDT = new Token(SupportedChainId.MAINNET, '0xdAC17F958D2ee523a2206206994597C13D831ec7', 6, 'USDT', 'Tether USD');
export var USDT_ARBITRUM_ONE = new Token(SupportedChainId.ARBITRUM_ONE, '0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9', 6, 'USDT', 'Tether USD');
export var USDT_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x94b008aA00579c1307B0EF2c499aD98a8ce58e58', 6, 'USDT', 'Tether USD');
export var WBTC = new Token(SupportedChainId.MAINNET, '0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599', 8, 'WBTC', 'Wrapped BTC');
export var WBTC_ARBITRUM_ONE = new Token(SupportedChainId.ARBITRUM_ONE, '0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f', 8, 'WBTC', 'Wrapped BTC');
export var WBTC_OPTIMISM = new Token(SupportedChainId.OPTIMISM, '0x68f180fcCe6836688e9084f035309E29Bf0A2095', 8, 'WBTC', 'Wrapped BTC');
export var FEI = new Token(SupportedChainId.MAINNET, '0x956F47F50A910163D8BF957Cf5846D573E7f87CA', 18, 'FEI', 'Fei USD');
export var TRIBE = new Token(SupportedChainId.MAINNET, '0xc7283b66Eb1EB5FB86327f08e1B5816b0720212B', 18, 'TRIBE', 'Tribe');
export var FRAX = new Token(SupportedChainId.MAINNET, '0x853d955aCEf822Db058eb8505911ED77F175b99e', 18, 'FRAX', 'Frax');
export var FXS = new Token(SupportedChainId.MAINNET, '0x3432B6A60D23Ca0dFCa7761B7ab56459D9C964D0', 18, 'FXS', 'Frax Share');
export var renBTC = new Token(SupportedChainId.MAINNET, '0xEB4C2781e4ebA804CE9a9803C67d0893436bB27D', 8, 'renBTC', 'renBTC');
export var ETH2X_FLI = new Token(SupportedChainId.MAINNET, '0xAa6E8127831c9DE45ae56bB1b0d4D4Da6e5665BD', 18, 'ETH2x-FLI', 'ETH 2x Flexible Leverage Index');
export var sETH2 = new Token(SupportedChainId.MAINNET, '0xFe2e637202056d30016725477c5da089Ab0A043A', 18, 'sETH2', 'StakeWise Staked ETH2');
export var rETH2 = new Token(SupportedChainId.MAINNET, '0x20BC832ca081b91433ff6c17f85701B6e92486c5', 18, 'rETH2', 'StakeWise Reward ETH2');
export var SWISE = new Token(SupportedChainId.MAINNET, '0x48C3399719B582dD63eB5AADf12A40B4C3f52FA2', 18, 'SWISE', 'StakeWise');
export var WETH_POLYGON_MUMBAI = new Token(SupportedChainId.POLYGON_MUMBAI, '0xa6fa4fb5f76172d178d61b04b0ecd319c5d1c0aa', 18, 'WETH', 'Wrapped Ether');
export var WETH_POLYGON = new Token(SupportedChainId.POLYGON, '0x7ceb23fd6bc0add59e62ac25578270cff1b9f619', 18, 'WETH', 'Wrapped Ether');
export var UNI = (_b = {},
    _b[SupportedChainId.MAINNET] = new Token(SupportedChainId.MAINNET, UNI_ADDRESS[1], 18, 'UNI', 'Uniswap'),
    _b[SupportedChainId.RINKEBY] = new Token(SupportedChainId.RINKEBY, UNI_ADDRESS[4], 18, 'UNI', 'Uniswap'),
    _b[SupportedChainId.ROPSTEN] = new Token(SupportedChainId.ROPSTEN, UNI_ADDRESS[3], 18, 'UNI', 'Uniswap'),
    _b[SupportedChainId.GOERLI] = new Token(SupportedChainId.GOERLI, UNI_ADDRESS[5], 18, 'UNI', 'Uniswap'),
    _b[SupportedChainId.KOVAN] = new Token(SupportedChainId.KOVAN, UNI_ADDRESS[42], 18, 'UNI', 'Uniswap'),
    _b);
export var WRAPPED_NATIVE_CURRENCY = __assign(__assign({}, WETH9), (_c = {}, _c[SupportedChainId.OPTIMISM] = new Token(SupportedChainId.OPTIMISM, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether'), _c[SupportedChainId.OPTIMISTIC_KOVAN] = new Token(SupportedChainId.OPTIMISTIC_KOVAN, '0x4200000000000000000000000000000000000006', 18, 'WETH', 'Wrapped Ether'), _c[SupportedChainId.ARBITRUM_ONE] = new Token(SupportedChainId.ARBITRUM_ONE, '0x82aF49447D8a07e3bd95BD0d56f35241523fBab1', 18, 'WETH', 'Wrapped Ether'), _c[SupportedChainId.ARBITRUM_RINKEBY] = new Token(SupportedChainId.ARBITRUM_RINKEBY, '0xB47e6A5f8b33b3F17603C83a0535A9dcD7E32681', 18, 'WETH', 'Wrapped Ether'), _c[SupportedChainId.POLYGON] = new Token(SupportedChainId.POLYGON, '0x0d500B1d8E8eF31E21C99d1Db9A6444d3ADf1270', 18, 'WMATIC', 'Wrapped MATIC'), _c[SupportedChainId.POLYGON_MUMBAI] = new Token(SupportedChainId.POLYGON_MUMBAI, '0x9c3C9283D3e44854697Cd22D3Faa240Cfb032889', 18, 'WMATIC', 'Wrapped MATIC'), _c));
function isMatic(chainId) {
    return chainId === SupportedChainId.POLYGON_MUMBAI || chainId === SupportedChainId.POLYGON;
}
var MaticNativeCurrency = /** @class */ (function (_super) {
    __extends(MaticNativeCurrency, _super);
    function MaticNativeCurrency(chainId) {
        if (!isMatic(chainId))
            throw new Error('Not matic');
        return _super.call(this, chainId, 18, 'MATIC', 'Polygon Matic') || this;
    }
    MaticNativeCurrency.prototype.equals = function (other) {
        return other.isNative && other.chainId === this.chainId;
    };
    Object.defineProperty(MaticNativeCurrency.prototype, "wrapped", {
        get: function () {
            if (!isMatic(this.chainId))
                throw new Error('Not matic');
            var wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId];
            if (!wrapped)
                throw new Error('WRAPPED_NATIVE_CURRENCY error ');
            return wrapped;
        },
        enumerable: false,
        configurable: true
    });
    return MaticNativeCurrency;
}(NativeCurrency));
var ExtendedEther = /** @class */ (function (_super) {
    __extends(ExtendedEther, _super);
    function ExtendedEther() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ExtendedEther.prototype, "wrapped", {
        get: function () {
            var wrapped = WRAPPED_NATIVE_CURRENCY[this.chainId];
            if (wrapped)
                return wrapped;
            throw new Error('Unsupported chain ID');
        },
        enumerable: false,
        configurable: true
    });
    ExtendedEther.onChain = function (chainId) {
        var _a;
        return (_a = this._cachedExtendedEther[chainId]) !== null && _a !== void 0 ? _a : (this._cachedExtendedEther[chainId] = new ExtendedEther(chainId));
    };
    ExtendedEther._cachedExtendedEther = {};
    return ExtendedEther;
}(Ether));
export { ExtendedEther };
var cachedNativeCurrency = {};
export function nativeOnChain(chainId) {
    var _a;
    return ((_a = cachedNativeCurrency[chainId]) !== null && _a !== void 0 ? _a : (cachedNativeCurrency[chainId] = isMatic(chainId)
        ? new MaticNativeCurrency(chainId)
        : ExtendedEther.onChain(chainId)));
}
export var TOKEN_SHORTHANDS = {
    USDC: (_d = {},
        _d[SupportedChainId.MAINNET] = USDC_MAINNET.address,
        _d[SupportedChainId.ARBITRUM_ONE] = USDC_ARBITRUM.address,
        _d[SupportedChainId.OPTIMISM] = USDC_OPTIMISM.address,
        _d[SupportedChainId.ARBITRUM_RINKEBY] = USDC_ARBITRUM_RINKEBY.address,
        _d[SupportedChainId.OPTIMISTIC_KOVAN] = USDC_OPTIMISTIC_KOVAN.address,
        _d[SupportedChainId.POLYGON] = USDC_POLYGON.address,
        _d[SupportedChainId.POLYGON_MUMBAI] = USDC_POLYGON_MUMBAI.address,
        _d[SupportedChainId.GOERLI] = USDC_GOERLI.address,
        _d[SupportedChainId.RINKEBY] = USDC_RINKEBY.address,
        _d[SupportedChainId.KOVAN] = USDC_KOVAN.address,
        _d[SupportedChainId.ROPSTEN] = USDC_ROPSTEN.address,
        _d),
};
